import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { useEffect, useState } from "react";
import Signal from "badmfck-signal";
import { GD } from "src/GD";
import { S_SELECT_ITEMS_POPUP } from "./SelectItemsPopup";
import { Box, VBox } from "@ui/box/Box";
import { Typo } from "@ui/text/Typo";
import { TerminalBadge } from "../conponents/TerminalBadge";
import { S_CONFIRM } from "./general/ConfirmDialog";
import { notify } from "../../tools/notify";

export const S_ADD_TERMINAL_POPUP = new Signal<{
	merchantID: number;
	onSuccess: () => void;
} | null>("S_ADD_TERMINAL_POPUP");

export const AddTerminalPopup = () => {
	useLocale();
	const requestData = S_ADD_TERMINAL_POPUP.use();

	const [terminals] = GD.B_TERMINALS.use({ ts: +new Date() });

	const [_busy, setBusy] = useState<boolean>();
	const [_error, setError] = useState<IError>();

	const closePopup = () => {
		S_ADD_TERMINAL_POPUP.invoke(null);
		setError(undefined);
		setBusy(false);
	};

	const showSelector = async () => {
		if (requestData) {
			let terminalsList = terminals?.data ?? [];

			const existing = await GD.B_MERCHANT_ATTACHED_TERMINALS.execute({
				merchantID: requestData.merchantID,
			});

			if (!existing?.error && existing?.data) {
				terminalsList = terminalsList.filter(t => !existing.data.find(t2 => t.id === t2.id));
			}

			if (terminalsList.length === 0) {
				S_CONFIRM.invoke({
					message: msg("allPossibleTerminalsHaveAlreadyBeenAdded"),
					confirm: "Back",
					reject:'Cancel',
					onResult: () => {},
				});
				closePopup();
			} else {
				S_SELECT_ITEMS_POPUP.invoke({
					title: msg("selectTerminal"),
					items: terminalsList,
					multi: false,
					gridColumns: "max-content max-content auto max-content max-content",
					order: ["__itemType", "type", "name", "id"],
					itemType: "terminal",
					searchable: terminalsList.length > 5,
					onClose: closePopup,
					cellFactory: (row, cell, _index: number, _key, name, sx) => {
						if (name === "type") {
							sx && (sx.padding = 0);
							sx && (sx.paddingLeft = "8px");
							sx && (sx.display = "unset");

							return {
								content: (
									<Box>
										<TerminalBadge terminal={row} />
									</Box>
								),
								sx,
							};
						}

						return { content: cell };
					},

					onSelected: async items => {
						if (items) {
							setBusy(true);

							const res = await GD.REQ_MERCHANT_RESTORE_TERMINAL.request({
								terminalID: items.map(i => i.id),
								merchantID: requestData.merchantID,
							});
							//!TODO:;
							if (res) {
								if (res.error) {
									notify.error(
										() => {
											return (
												<VBox gap="8px">
													<Typo variant="text">{res.error.message}</Typo>
													{res.error.details && <Typo variant="medium">{res.error.details}</Typo>}
												</VBox>
											);
										}
									);
								} else {
									notify.info(msg("added"));
								}
							}
						}

						closePopup();

						setBusy(false);
					},
				});
			}
		}
	};

	//!TODO: loader, error
	useEffect(() => {
		if (requestData && terminals) {
			showSelector();
		}
	}, [requestData, terminals]);

	if (!requestData) return null;

	return null;
};
